import {ChangeEvent, useEffect, useState} from "react";
import {loginUserTC, setInitialDataTC} from "../../state/reducers/user-reducer.ts";
import {useAppDispatch} from "../useAppDispatch.ts";
import {useNavigate} from "react-router-dom";
import {appActions} from "../../state/reducers/app-reducer.ts";
import {showCustomErrorToast} from "../../utils/customErrorToast.tsx";
import {useTranslation} from "react-i18next";
import {getNearestTimezoneAndSave} from "../../dateUtils/dateUtils.ts";
import {useModal} from "../../context/ModalContext.tsx";

const UseLogin = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const refCode = window.Telegram?.WebApp.initDataUnsafe.start_param
    const [refCodeState, setRefCodeState] = useState('');
    const [isRefCodeExist, setIsRefCodeExist] = useState(false);
    const [errState, setErrState] = useState(false);
    const userNameTg = window.Telegram?.WebApp.initDataUnsafe.user?.username || 'test';
    const [userName, setUserName] = useState(userNameTg)
    const onChangeRefCodeExist = () => {
        setIsRefCodeExist(!isRefCodeExist)
    }
    const onChangeRefCodeValue = (event: ChangeEvent<HTMLInputElement>) => {
        setRefCodeState(event.currentTarget.value)
    };

    const {t} = useTranslation();
    const {openModal} = useModal();

    const openRefTerms = () => {
        openModal('REFERRAL_PROGRAM_TERMS', {
            isOpen: true,
        })
    }
    useEffect(() => {
        dispatch(setInitialDataTC(navigate))
            .then(() => {
                navigate('/')
            }).catch(() => {
        })
    }, []);

    useEffect(() => {
        if (refCode) {
            setRefCodeState(refCode)
            setIsRefCodeExist(true)
            setIsRefCodeExist(true)
        }
    }, []);

    const onChangeLogin = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.currentTarget.value === "") {
            setErrState(false)
        }
        setUserName(e.target.value)
    }

    const sendForm = () => {
        dispatch(appActions.initializeStateOfApp(true));

        if (userName) {
            if (refCodeState) {
                const timezone = getNearestTimezoneAndSave()
                dispatch(loginUserTC(navigate, {
                    contact_telegram_account: userName,
                    referral_code: refCodeState,
                    timezone: timezone.value
                }))
                    .then(() => {
                    })
                    .catch(() => {
                        setErrState(true)
                        console.log('err')
                        showCustomErrorToast(t('pages.login.errorResponse'), 'login_id', 'bottom-center')
                    });
            } else {
                dispatch(loginUserTC(navigate, {
                    contact_telegram_account: userName,
                })).then(() => {
                }).catch(() => {
                    setErrState(true)
                    showCustomErrorToast(t('pages.login.errorResponse'), 'login_id', 'bottom-center')
                });
            }
        }
    };

    return {
        t,
        onChangeRefCodeExist,
        onChangeLogin,
        isRefCodeExist,
        refCodeState,
        onChangeRefCodeValue,
        userName,
        errState,
        sendForm,openRefTerms
    }
}
export default UseLogin;